export enum NotificationsEndpoints {
    GetSubscription = "ms-ux-mep-gestion-de-notificaciones-cliente-pga/servicio-al-cliente/v1/api/insureds/me/notification-subscriptions",
    CreateSubscription = "ms-ux-mep-gestion-de-notificaciones-cliente-pga/servicio-al-cliente/v1/api/insureds/me/notification-subscriptions",
    UpdateSubscription = "ms-ux-mep-gestion-de-notificaciones-cliente-pga/servicio-al-cliente/v1/api/insureds/me/notification-subscriptions/:subscriptionId",
}
